export default "__VITE_ASSET__BnDNSpTl__"